import { useHeaderStore } from '#commerce/stores/header'

/**
 * Returns a `Ref<number>` containing the current sticky-header offset in pixels, updated only
 * after `onMounted` so SSR / hydration produces a stable `0` initial value (avoids mismatch
 * warnings caused by reading `header.height.*` during SSR).
 * @returns Ref tracking the live header offset; defaults to `0` on the server / before mount.
 */
export const useHydrationSafeHeaderOffsetPx = () => {
  const header = useHeaderStore()
  const offsetPx = ref(0)

  onMounted(() => {
    watch(
      () => (header.transparent ? header.height.promoBar : header.height.full) || 0,
      (value) => {
        offsetPx.value = value
      },
      { immediate: true },
    )
  })

  return offsetPx
}
